var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartControlZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Interactive-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B7B7B7",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,9 L10.8333333,9 L10.8333333,4.83333333 C10.8333333,4.37309604 10.4602373,4 10,4 C9.53976271,4 9.16666667,4.37309604 9.16666667,4.83333333 L9.16666667,9 L5,9 C4.53976271,9 4.16666667,9.37309604 4.16666667,9.83333333 C4.16666667,10.2935706 4.53976271,10.6666667 5,10.6666667 L9.16666667,10.6666667 L9.16666667,14.8333333 C9.16666667,15.2935706 9.53976271,15.6666667 10,15.6666667 C10.4602373,15.6666667 10.8333333,15.2935706 10.8333333,14.8333333 L10.8333333,10.6666667 L15,10.6666667 C15.4602373,10.6666667 15.8333333,10.2935706 15.8333333,9.83333333 C15.8333333,9.37309604 15.4602373,9 15,9 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartControlZoomIn);
export default __webpack_public_path__ + "static/media/chartControl_ZoomIn.87cd13570ad846e5a72c587a0acc21e8.svg";
export { ForwardRef as ReactComponent };